









































import { Component, Vue } from "vue-property-decorator";
import "./layout.css";
import CountryService from "@/services/country.service";
@Component({
  components: {}
})
export default class LayoutComponent extends Vue {
  countryService: CountryService = new CountryService();
  loading = true;

  get isLoading(){
    return this.$store.state.loading;
  }
  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }
  get isMobile() {
    return this.$store.getters.isMobile;
  }
  get showSidebar() {
    return this.$store.state.showSidebar;
  }
  toggleSidebar() {
    this.$store.commit("set_showSidebar", !this.showSidebar);
  }
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize);
    }
  }
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    this.getDefaultCountry();
  }
  onResize() {
    this.$store.state.isMobile = window.innerWidth < 1088;
  }
  getDefaultCountry() {
    this.countryService
      .getDefault()
      .then(x => {
        this.$store.commit("setDefaultCountry", x);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
